<div class="card card-body mb-0">
    <form [formGroup]="reportForm" (ngSubmit)="onSubmit()">
        <div class="common-form row g-3">
            <div class="col-12">
                <div class="form-group">
                    <label class="fw-bold">{{ "PROPERTIES.Radnik" | translate }}</label>
                    <ng-select [items]="radnici" loadingText="Ucitavanje..." [virtualScroll]="true"
                        bindLabel="imePrezime" bindValue="sifra" formControlName="radnik" [clearable]="false">
                        <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                            <div>{{ item.ime }} {{ item.prezime }}</div>
                        </ng-template>
                    </ng-select>
                    <ng-container [ngTemplateOutlet]="formError" [ngTemplateOutletContext]="{
                    validation: 'required',
                    message: 'VALIDATORS.PoljeNeSmijeBitiPrazno',
                    control: reportForm.controls.radnik
                  }">
                    </ng-container>
                </div>
            </div>

            <div class="col-12 text-end mt-2 mb-0">
                <button class="btn btn-light me-2" (click)="closeModal()" type="button">
                    {{"PROPERTIES.Otkazi" | translate}}
                </button>
                <button class="btn btn-primary" type="submit">
                    {{"PROPERTIES.SpremiIzmjene" | translate}}
                </button>
            </div>
        </div>
    </form>
</div>

<ng-template #formError let-control="control" let-message="message" let-validation="validation">
    <ng-container *ngIf="control.hasError(validation) && control.touched">
        <small class="text-danger">{{ message | translate }}</small>
    </ng-container>
</ng-template>